import { RadioGroup, RadioGroupItem } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../translations';
import { MedicalProfileTabFormController, SectionRowViewModel } from '../../tab/MedicalProfileTab.types';
import { createFormFieldName } from '../../tab/MedicalProfileTab.utils';

type GateRadioGroupFieldProps = Pick<MedicalProfileTabFormController, 'register'> & {
   readonly templateCode: string;
   readonly row: SectionRowViewModel;
   readonly disabled: boolean;
};

export const GateRadioGroupField = (props: GateRadioGroupFieldProps): JSX.Element => {
   const items: RadioGroupItem<string>[] = props.row.gateOptions.map((gateOption) => ({
      id: gateOption.code,
      label: appointmentsTranslationKeys.medicalProfile.gateOptionMap[gateOption.kind],
   }));

   return (
      <RadioGroup
         testId={`gate-${props.row.sectionId}`}
         items={items}
         controller={props.register(createFormFieldName(props.templateCode, props.row.gateQuestionId))}
         defaultValue={props.row.initialGateCode ?? null}
         disabled={props.disabled}
         horizontal
      />
   );
};
